"use client";

import { Trigger } from "@radix-ui/react-select";
import { useContext } from "react";

import { SETTLEMENT_CURRENCY } from "@trip/constants";

import { CurrencyContext } from "~/components/currency-provider";
import { CurrencyIcon } from "~/components/icons/currency-icon";
import { Select, SelectContent, SelectItem } from "~/components/ui/select";
import { updateCurrency } from "~/server/actions";

export function CurrencyPicker() {
  const { currency, currencies } = useContext(CurrencyContext);

  return (
    <Select
      onValueChange={(value) => {
        const currencyProps = currencies.find(
          (currencyProps) => value === currencyProps.code,
        );
        if (currencyProps) {
          void updateCurrency(currencyProps.code);
        } else {
          void updateCurrency(SETTLEMENT_CURRENCY);
        }
      }}
      value={currency.code}
    >
      <Trigger className="" aria-label="Currency">
        <CurrencyIcon />
      </Trigger>
      <SelectContent align="center">
        {currencies.map(({ code, symbol }) => (
          <SelectItem
            key={code}
            value={code}
          >{`${symbol} ${code.toUpperCase()}`}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
